import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { LoadingService } from '../../services/loading.service';


@Component({
  selector: 'app-table-loading-overlay',
  standalone: true,
  imports: [CommonModule, ProgressSpinnerModule],
  template: `
    <div
      *ngIf="loadingService.tableLoading()"
      class="absolute inset-0 z-10 bg-white/60 flex items-center justify-center backdrop-blur-sm" style="z-index: 9999;"
    >
      <p-progressSpinner></p-progressSpinner>
    </div>
  `,
})
export class AppTableLoadingOverlayComponent {
  constructor(public loadingService: LoadingService) {}
}

